<template>
  <button id="CHANNEL_DOWN" name="CHANNEL_DOWN" class="btn" data-vcode="CHANNEL_DOWN">
    <img class="soft-img" src="/images/icn-channel-down.svg" alt="" role="img" aria-hidden="true" />
    <label>{{ $t('channelDown') }}</label>
  </button>
</template>
<script>
export default {};
</script>
